module.exports = __webpack_public_path__ + "assets/img/22@3x.16f6e4dd.png";